/* koppa-guide.js: carousels, the reviews switcher and the sticky buy bar for guide landing pages. */
(() => {
  const init = () => {
    document.querySelectorAll('[data-kgp-carousel]').forEach((root) => {
      const track = root.querySelector('[data-kgp-track]');
      if (!track || track.dataset.kgReady) return;
      track.dataset.kgReady = 'true';
      const slides = Array.from(track.children);
      const prev = root.querySelector('[data-kgp-prev]');
      const next = root.querySelector('[data-kgp-next]');
      const dots = root.querySelector('[data-kgp-dots]');
      const gap = () => parseFloat(getComputedStyle(track).columnGap) || 16;
      const step = () => (slides[0] ? slides[0].getBoundingClientRect().width + gap() : track.clientWidth);
      const index = () => Math.round(track.scrollLeft / step());
      const perView = () => Math.max(1, Math.round((track.clientWidth + gap()) / step()));
      const go = (i) => {
        const last = Math.max(0, slides.length - perView());
        track.scrollTo({ left: Math.max(0, Math.min(i, last)) * step(), behavior: 'smooth' });
      };
      if (prev) prev.addEventListener('click', () => go(index() - 1));
      if (next) next.addEventListener('click', () => go(index() + 1));
      const dotEls = [];
      if (dots) {
        slides.forEach((_, i) => {
          const b = document.createElement('button');
          b.type = 'button';
          b.setAttribute('aria-label', 'Show item ' + (i + 1));
          b.addEventListener('click', () => go(i));
          dots.appendChild(b);
          dotEls.push(b);
        });
      }
      const paint = () => {
        const i = index();
        const last = Math.max(0, slides.length - perView());
        dotEls.forEach((b, j) => {
          const on = j === i;
          if (on) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current');
          b.hidden = j > last;
        });
        if (prev) prev.disabled = i <= 0;
        if (next) next.disabled = i >= last;
      };
      track.addEventListener('scroll', () => requestAnimationFrame(paint), { passive: true });
      window.addEventListener('resize', paint);
      paint();
    });

    document.querySelectorAll('[data-kgp-reviews]').forEach((root) => {
      if (root.dataset.kgReady) return;
      root.dataset.kgReady = 'true';
      const items = Array.from(root.querySelectorAll('[data-kgp-rv-item]'));
      const tabs = Array.from(root.querySelectorAll('[data-kgp-rv-tab]'));
      const current = root.querySelector('[data-kgp-rv-current]');
      const prev = root.querySelector('[data-kgp-rv-prev]');
      const next = root.querySelector('[data-kgp-rv-next]');
      let i = 0;
      const show = (n) => {
        if (!items.length) return;
        i = (n + items.length) % items.length;
        items.forEach((el, j) => { el.hidden = j !== i; });
        tabs.forEach((t, j) => t.setAttribute('aria-pressed', j === i ? 'true' : 'false'));
        if (current) current.textContent = (i + 1 < 10 ? '0' : '') + (i + 1);
      };
      if (prev) prev.addEventListener('click', () => show(i - 1));
      if (next) next.addEventListener('click', () => show(i + 1));
      tabs.forEach((t, j) => t.addEventListener('click', () => show(j)));
    });

    const bar = document.querySelector('[data-kgp-sticky]');
    const hero = document.querySelector('[data-kgp-hero]');
    if (bar && hero && 'IntersectionObserver' in window) {
      const shop = document.getElementById('shop');
      let heroGone = false;
      let shopSeen = false;
      let dismissed = false;
      const apply = () => {
        const show = heroGone && !shopSeen && !dismissed;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      };
      new IntersectionObserver(([e]) => { heroGone = !e.isIntersecting && e.boundingClientRect.top < 0; apply(); }, { threshold: 0 }).observe(hero);
      if (shop) new IntersectionObserver(([e]) => { shopSeen = e.isIntersecting; apply(); }, { threshold: 0.1 }).observe(shop);
      const close = bar.querySelector('[data-kgp-sticky-close]');
      if (close) close.addEventListener('click', () => { dismissed = true; apply(); });
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
